import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {ApiService} from '@modules/api-service';
import {jobTypes} from '@modules/constants-enumerate';

/**
 * @summary ExportSearchJob
 * @extends {AoflElement}
 */
@customElement('export-search-job')
class ExportSearchJob extends AoflElement {
  /**
   * Creates an instance of ExportSearchJob.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static get is() {
    return 'export-search-job';
  }

  @property({type: Object, attribute: false})
  job = {};

  clickHandler = async () => {
    let url = '';
    const jobInfo = await ApiService.userJobGet(this.job.id); // eslint-disable-line
    if (jobInfo?.job_type === jobTypes.DASHBOARD_CSV_EXPORT) {
      url = await ApiService.getDownloadDashboardCSVUrl(this.job.id);
    } else {
      url = await ApiService.getDownloadFileUrl(jobInfo.payload_json.file_key);
    }
    window.open(url, '_blank');
  }

  /**
   * @param {Event} e
   */
  keydownHandler(e) {
    if (e.key === 'Enter' || e.code === 'Space') {
      this.clickHandler();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.keydownHandler);
    this.addEventListener('click', this.clickHandler);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.keydownHandler);
    this.removeEventListener('click', this.clickHandler);
  }
}

export default ExportSearchJob;
